export default "__VITE_ASSET__BHVf6$K1__"